export default __webpack_public_path__ + "static/media/April2023.fbda7ef8.jpg";